import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Ticket } from "lucide-react";

export default function AdminLogin() {
  const { login, user, ready } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (ready && user) navigate("/admin");
  }, [ready, user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#14283A] px-5">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex items-center justify-center gap-2 text-[#F6F1E8]">
          <span className="grad-bar flex h-9 w-9 items-center justify-center rounded-lg text-white">
            <Ticket className="h-5 w-5" />
          </span>
          <span className="font-display text-xl">SZN TRIP · ADMIN</span>
        </div>
        <form
          onSubmit={submit}
          className="rounded-2xl border-2 border-[#EA7A4F] bg-white p-8"
          data-testid="admin-login-form"
        >
          <h1 className="font-display text-2xl text-[#14283A]">Connexion</h1>
          <p className="mt-1 text-sm text-[#14283A]/60">Espace de pilotage du site.</p>

          <div className="mt-6 space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-email"
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Mot de passe</Label>
              <Input
                id="password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password"
              />
            </div>
          </div>

          {error && (
            <p className="mt-4 text-sm font-medium text-red-600" data-testid="admin-login-error">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="grad-bar mt-6 flex w-full items-center justify-center gap-2 rounded-full py-3 font-bold text-white transition-transform hover:scale-[1.02] active:scale-95 disabled:opacity-60"
            data-testid="admin-login-submit"
          >
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
            Se connecter
          </button>
        </form>
      </div>
    </div>
  );
}
